import type { OmpCriticalityBand } from '@evimo/types/enums/omp-criticality-band';

export const OMP_CRITICALITY_COLORS: Record<OmpCriticalityBand, string> = {
  critical: '#e23b4a',
  high: '#ec7e00',
  medium: '#faad14',
  low: '#00a87e',
};
